import Board from './Board'
import IndividualCut from './IndividualCut'

class CutCalculator {
  static get defaultMargin() { return 5 }

  constructor(attributes = {}) {
    this.boardLength = attributes.boardLength
    this.margin = attributes.margin || CutCalculator.defaultMargin
    this.cuts = [];
    this.boards = []

    for (let cut of attributes.cuts) {
      for (let index = 0; index < cut.quantity; index++) {
        this.cuts.push(new IndividualCut(cut))
      }
    }

    this.sortCuts()
  }

  sortCuts() {
    for (let cut of this.cuts) {
      let board = this.boards.find((b) => {
        return b.willFit(cut)
      }) || new Board(this.boardLength)
      if (board.cuts.length === 0) this.boards.push(board)
      board.addCut(cut)
    }
  }

  output() {
    return this.boards.map(b => { return b.inspect() }).join("\n\n\n")
  }

}
export default CutCalculator;
